module.exports = __webpack_public_path__ + "media/svg/il-11d095d6.svg";